import { render, staticRenderFns } from "./ColorCross.vue?vue&type=template&id=55edfdbe&"
import script from "./ColorCross.vue?vue&type=script&lang=js&"
export * from "./ColorCross.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/3672/203/Bigtex5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55edfdbe')) {
      api.createRecord('55edfdbe', component.options)
    } else {
      api.reload('55edfdbe', component.options)
    }
    module.hot.accept("./ColorCross.vue?vue&type=template&id=55edfdbe&", function () {
      api.rerender('55edfdbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/bigtex/ColorCross.vue"
export default component.exports